function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// @ts-strict-ignore
/** @jsx jsx */
/** @jsxFrag null */
import { jsx, ParamComponent } from 'panel';
import { ButtonEl } from 'common/components/button';
import { ButtonSize, ButtonTheme } from 'common/components/button/constants';
import { TagInputEl } from 'common/components/tag-input';
import { TagItem } from 'common/components/tag-input/tag-item';
import { defineAndMakeJsxFactory } from 'common/util/jsx';
import { panel2react } from 'common/util/react';
import { Section } from 'common/components/items-menu/types';
import { SelectEl } from 'common/components/select';
import { SelectTheme } from 'common/components/select/constants';
import { Directions } from 'common/components/drop-menu/types';
import { IronContextRegistry } from 'common/report/context-registry';
import css from './index.inline.styl';
interface Params {
  tags: TagItem[];
  selectOptions: Section[];
  disabled: boolean;
  placeholder: string;
  menuSections: Section[];
  sectionsFromInputFn?: (input) => Section[];
  openOnRefresh?: boolean;
  preserveSearchOnTagClick?: boolean;
  cta: {
    text: string;
    disabled: boolean;
    onClick: () => void;
    icon: string;
  };
  selectedInputOption: any;
  itemMenuKeydownProxy?: any;
  picker: {
    handleInputChange: (ev) => void;
    handleLevelSelectChange: (ev) => void;
    handleItemClick: (ev) => void;
  };
  searchText: string;
  label: string;
  showPopover: boolean;
}
interface UserSearchTagInputProps {
  props?: Params;
}
export class UserSearchTagInput extends ParamComponent<Params, EmptyObj, IronContextRegistry> {
  get config() {
    return {
      css,
      useShadowDom: true,
      contexts: ["i18n" as const],
      params: {
        tags: Array,
        selectOptions: Array,
        disabled: Boolean,
        placeholder: String,
        menuSections: Array,
        openOnRefresh: Boolean,
        preserveSearchOnTagClick: Boolean,
        itemMenuKeydownProxy: Object,
        cta: Object,
        selectedInputOption: String,
        sectionsFromInputFn: Function,
        picker: Object,
        searchText: String,
        label: String,
        showPopover: Boolean
      },
      template: () => {
        var _this$params$label, _this$params$placehol;
        const roleSelectEl = <SelectEl attrs={{
          tabindex: 0,
          elref: "selectShareLevel",
          'disable-search': true,
          'menu-alignment': Directions.DownRight,
          'menu-width': null,
          'selected-option': this.params.selectedInputOption,
          theme: SelectTheme.Tertiary,
          'always-show-caret': true,
          disabled: this.params.disabled
        }} params={{
          sections: this.params.selectOptions
        }} on={{
          click: ev => ev.stopPropagation(),
          focus: ev => {
            ev.preventDefault();
            ev.stopPropagation();
          },
          change: ev => {
            ev.stopPropagation();
            this.params.picker.handleLevelSelectChange(ev);
          }
        }} />;
        const {
          t
        } = this.getContext("i18n");
        return <div sel='.picker-wrapper' key='wrapper'>
            <div sel='.picker-controls'>
              <TagInputEl attrs={{
              label: (_this$params$label = this.params.label) !== null && _this$params$label !== void 0 ? _this$params$label : t("components.sharing.invite"),
              tags: this.params.tags,
              elref: "sharingTagInput",
              placeholder: (_this$params$placehol = this.params.placeholder) !== null && _this$params$placehol !== void 0 ? _this$params$placehol : t("components.sharing.invite-placeholder"),
              'min-tags': 0,
              disabled: this.params.disabled,
              multiline: true,
              'controlled-mode': true
            }} on={{
              clickMenuItem: this.params.picker.handleItemClick,
              change: this.params.picker.handleInputChange
            }} props={{
              suffixRenderer: () => roleSelectEl,
              menuSections: this.params.menuSections,
              sectionsFromInputFn: this.params.sectionsFromInputFn,
              openOnRefresh: this.params.openOnRefresh,
              preserveSearchOnTagClick: this.params.preserveSearchOnTagClick
            }} />
              <ButtonEl sel='.save-share' attrs={_objectSpread({
              disabled: this.params.cta.disabled,
              elref: "saveNewSharesButton",
              size: ButtonSize.Large,
              theme: ButtonTheme.Primary
            }, this.params.cta.icon ? {
              icon: this.params.cta.icon
            } : {})} on={{
              click: this.params.cta.onClick
            }}>
                {this.params.cta.text}
              </ButtonEl>
            </div>
          </div>;
      }
    };
  }
}
export const UserSearchTagInputEl = defineAndMakeJsxFactory("mp-user-search-tag-input", UserSearchTagInput);
export const UserSearchTagInputReact = panel2react<UserSearchTagInputProps>("mp-user-search-tag-input", UserSearchTagInput);